var _rect, _path, _text;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTigalyAiLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 138 32",
    role: "img",
    "aria-label": "Tigaly AI",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 8,
    fill: "#FF6B1A"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 6L11 6Q12.5 6 12.07 7.44L6.74 25.19Q6.5 26 5.65 26L5.35 26Q4.5 26 4.67 25.17L8.21 7.47Q8.5 6 10 6ZM16.5 6L17.5 6Q19 6 18.57 7.44L13.24 25.19Q13 26 12.15 26L11.85 26Q11 26 11.17 25.17L14.71 7.47Q15 6 16.5 6ZM23 6L24 6Q25.5 6 25.19 7.47L22.68 19.17Q22.5 20 21.65 20L21.35 20Q20.5 20 20.56 19.15L21.39 7.5Q21.5 6 23 6Z",
    fill: "#121212"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 44,
    y: 24.5,
    textLength: 93,
    lengthAdjust: "spacingAndGlyphs",
    fontFamily: "system-ui, -apple-system, 'Segoe UI', 'Helvetica Neue', Helvetica, Arial, sans-serif",
    fontSize: 24,
    fontWeight: 800,
    letterSpacing: -0.96,
    fill: "#121212"
  }, "Tigaly ", /*#__PURE__*/React.createElement("tspan", {
    fill: "#FF6B1A"
  }, "AI"))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTigalyAiLogo);
export default __webpack_public_path__ + "static/media/tigaly-ai-logo.1b6367f8f1d16a178dd088c185711fdd.svg";
export { ForwardRef as ReactComponent };